var TrilliumFundRaisingCampaign = (function ($) {

    var containerSelector = ".fund-raising-campaign-container";

    var frequencySelector = "#donationFrequency";
    var frequencyCTASelector = ".donation-frequency-cta";

    var amountSelector = "#donationAmount";
    var amountCTASelector = ".donation-amount-cta";

    var checkIfContainerExists = function () {
        if ($(containerSelector) !== null &&
            $(containerSelector).length) {
            return true;
        }
        return false;
    };

    var boundDonationFrequencyCallback = function () {
        $(containerSelector).on('click', frequencyCTASelector, function () {
            var val = $(this).attr('data-value');
            if (val !== undefined) {
                $(frequencySelector).val(val);
            }
        });
    };

    var boundDonationAmountCallback = function () {
        $(containerSelector).on('click', amountCTASelector, function () {
            console.log("fundrasigin");
            var val = $(this).attr('data-value');
            if (val !== undefined) {
                $(amountSelector).val(val);
            }
        });
    };

    return {
        init: function () {
            if (checkIfContainerExists()) {
                boundDonationFrequencyCallback();
                boundDonationAmountCallback();
            }
        }
    };

})(window.jQuery);

window.TrilliumFundRaisingCampaign = TrilliumFundRaisingCampaign;
